module.exports = __webpack_public_path__ + "static/media/4.31922f63.jpeg";